/**
 * Format a date string to New Zealand format (dd/mm/yyyy)
 * @param dateString - The date string to format
 * @param includeTime - Whether to include time in the format
 * @returns Formatted date string in NZ format
 */
export const formatNZDate = (dateString: string | null | undefined, includeTime: boolean = false): string => {
  if (!dateString || dateString === 'Never' || dateString === 'Unknown') {
    return dateString || 'Never';
  }

  try {
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return dateString;
    }

    if (includeTime) {
      return date.toLocaleString('en-NZ', {
        day: '2-digit',
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } else {
      return date.toLocaleDateString('en-NZ', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  } catch (error) {
    console.warn('Error formatting date:', dateString, error);
    return dateString;
  }
};

/**
 * Format a date for display in campaign tables
 * @param dateString - The campaign date string
 * @returns Formatted date string in dd/mm/yyyy format
 */
export const formatCampaignDate = (dateString: string | null | undefined): string => {
  return formatNZDate(dateString, false);
};

/**
 * Format a date for display in subscriber last order column
 * @param dateString - The last order date string
 * @returns Formatted date string in dd/mm/yyyy format
 */
export const formatLastOrderDate = (dateString: string | null | undefined): string => {
  return formatNZDate(dateString, false);
};

/**
 * Format a date with time for order history tables
 * @param dateString - The order date string
 * @returns Formatted date string with time in NZ format
 */
export const formatOrderDateTime = (dateString: string | null | undefined): string => {
  return formatNZDate(dateString, true);
}; 